'use client';

import { Box, Button, Circle, Text } from '@chakra-ui/react';

import { IndicatorButtonProps } from '@app/components/atoms/indicator-button';

export const IndicatorButton = ({
    icon,
    children,
    withIndicator,
    ...props
}: IndicatorButtonProps) => (
    <Button variant={'ghost'} color={'gray.950'} fontWeight={'600'} h={8} py={1} {...props}>
        <Box position={'relative'} alignSelf={'middle'}>
            {icon ?? null}

            {withIndicator ? (
                <Circle
                    bg={'brand.solid'}
                    size={'12px'}
                    border={'2px solid'}
                    borderColor={'white'}
                    color={'white'}
                    position={'absolute'}
                    top={-0.5}
                    right={-0.5}
                />
            ) : null}
        </Box>
        <Text as={'span'} fontSize={'sm'}>
            {children}
        </Text>
    </Button>
);
